<div class="insurance-dialog">
  <!-- Header -->
  <div class="header">
    <button mat-icon-button (click)="onClose()" class="me-3">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h2 class="title">
      Insurance Information: {{ vehicle.manufacturer }} {{ vehicle.model }}
    </h2>
  </div>

  <!-- Status and Date -->
  <div class="date-section">
    <span class="label">Date Added/Edited:</span>
    <span class="value">{{ getInsuranceDate() }}</span>
  </div>

  <!-- Vehicle Information Section -->
  <mat-expansion-panel
    [(expanded)]="vehicleInfoExpanded"
    class="vehicle-info-section"
  >
    <mat-expansion-panel-header>
      Vehicle Information
    </mat-expansion-panel-header>

    <div>
      <div class="value mb-1">
        {{ vehicle.manufacturer }} {{ vehicle.model }}
      </div>
      <div class="label mb-1">{{ vehicle.registration }}</div>
      <div class="label">Engine number: {{ vehicle.vin }}</div>
    </div>
  </mat-expansion-panel>

  <!-- Policy Information Section -->
  <div class="policy-section">
    <div class="section-header">Policy Information</div>

    <div class="policy-details">
      <div class="policy-item">
        <span class="label">Insurance Company</span>
        <span class="value">{{ insurance.companyName || '-' }}</span>
      </div>

      <div class="policy-item">
        <span class="label">Policy number</span>
        <span class="value">{{ insurance.policyNumber || '-' }}</span>
      </div>

      <div class="policy-item">
        <span class="label">Claims email address</span>
        <span class="value">{{ insurance.claimEmailAddress || '-' }}</span>
      </div>

      <div class="policy-item">
        <span class="label">Claims telephone number</span>
        <span class="value">{{ insurance.claimPhoneNumber || '-' }}</span>
      </div>
    </div>
  </div>

  <!-- Policy Documents Section -->
  <div class="documents-section">
    <div class="section-header">Policy Documents</div>

    <div class="document-list">
      @for (document of insurance.documents; track document.id) {
      <app-vehicle-insurance-document [document]="document" />
      }
    </div>
  </div>

  <!-- Current Assigned Driver Section -->
  <div class="driver-section">
    <div class="section-header">Current assigned driver</div>

    @if (user) {
    <div class="driver-details">
      @if (user.profile?.image) {
      <div class="driver-avatar">
        <img [src]="user.profile!.image" alt="Driver Avatar" />
      </div>
      } @else {
      <div class="driver-avatar">
        <mat-icon>person</mat-icon>
      </div>
      }
      <div>
        <div class="value">{{ getDriverName() }}</div>
        <!-- <div class="label">{{ user.profile.email }}</div> -->
      </div>
    </div>
    } @else {
    <div class="no-driver">
      <span>No driver assigned</span>
    </div>
    }
  </div>
</div>
